
	export default {
		props: {
			rules: Object,
			answers: {
				type: Object,
				default: () => ({})
			},
			score: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				lines: {},
				checkboxes: [
					{
						title: "ACEi/ARB", 
						fullTitle: 'ACEi/ARB',
						type: 'radio',
						name: 'radio-1'
					},
					{
						title: "ARNI", 
						fullTitle: 'Angiotension Receptor Neprilysin Inhibitor',
						type: 'radio',
						name: 'radio-1'
					},
					{
						title: "Anticoagulant", 
						fullTitle: 'Anticoagulant',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "SGLTi", 
						fullTitle: 'Sodium Glucose Co-Transporter Inhbitor',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "GLP1-RA", 
						fullTitle: 'GLP-1 Receptor Antagonist.',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Statin", 
						fullTitle: 'Statin',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Additional LLT", 
						fullTitle: 'Additional LLT',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Evi. Based BB >50% max Dose", 
						fullTitle: 'Evi. Based BB >50% max Dose',
						type: 'radio',
						name: 'radio-2'
					},
					{
						title: "Evi. Based BB <50% max Dose", 
						fullTitle: 'Evi. Based BB <50% max Dose',
						type: 'radio',
						name: 'radio-2'
					},
					{
						title: "nsMRA", 
						fullTitle: 'Non-steroidal Mineralocorticoid Receptor Antagonist',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "sMRA", 
						fullTitle: 'Steroidal Mineralocorticoid Receptor Antagonist',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "BetaBlocker", 
						fullTitle: 'Beta Blocker',
						type: 'checkbox',
						name: 'checkbox'
					}
				]
			}
		},
		watch: {
			answers: {
				handler(newVal, oldVal) {
					this.$nextTick(() => {
						requestAnimationFrame(() => {
			                this.drawLines();
			            });
					});
				},
				deep: true,
				immediate: false,
			}
		},
		mounted() {
			this.$nextTick(() => {
				requestAnimationFrame(() => {
	                this.drawLines();
	            });
			});
		},
		methods: {
			drawLines() {
			    const fourthLi  = document.querySelectorAll('.cols-fourth li');
			    const fourthLiSelected  = document.querySelectorAll('.cols-fourth li.selected');
		        const selectedFirst = this.answers.questionFirst || [];
		        const lines = [];
		        const map = {
			        'AFF': {
			            color: '#e74c3c',
			            third: ['age', 'sex', 'C2VScore'],
			            fourth: { 
			            	'age': ['Anticoagulant'],
			            	'sex': ['Anticoagulant'],
			            	'C2VScore': ['Anticoagulant'],
			            }
			        },
			        'ChronicKidneyDisease': {
			            color: '#27ae60',
			            third: ['egfr', 'albuminuria'],
			            fourth: {
			            	'egfr': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'ACEiARB'],
			            	'albuminuria': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'ACEiARB'],
			            }
			        },
			        'ASCVD': {
			            color: '#f39c12',
			            second: ['DM', 'Obesity'],
			            third: ['age', 'sex', 'egfr', 'ldlc'],
			            fourth: {
			            	'age': ['SGLTi', 'GLP1-RA', 'Statin', 'AdditionalLLT'],
			            	'sex': ['SGLTi', 'GLP1-RA', 'Statin', 'AdditionalLLT'],
			            	'egfr': ['SGLTi', 'GLP1-RA', 'Statin', 'AdditionalLLT'],
			            	'ldlc': ['SGLTi', 'GLP1-RA', 'Statin', 'AdditionalLLT'],
			            }
			        },
			        'HF': {
			            color: '#3498db',
			            second: ['Obesity'],
			            third: ['age', 'sex', 'egfr', 'k', 'scr', 'ef'],
			            fourth: {
			            	'age': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'sex': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'egfr': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'k': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'scr': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'ef': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            }
			        },
			        'HFrEFHFmrEF': {
			            color: '#3498db',
			            second: ['Obesity'],
			            third: ['age', 'sex', 'egfr', 'k', 'scr'],
			            fourth: {
			            	'age': ['BetaBlocker'],
			            	'sex': ['BetaBlocker'],
			            	'egfr': ['BetaBlocker'],
			            	'k': ['BetaBlocker'],
			            	'scr': ['BetaBlocker'],
			            }
			        },
			        'HFpEF': {
			            color: '#3498db',
			            second: ['Obesity'],
			            third: ['age', 'sex', 'egfr', 'k', 'scr', 'ef'],
			            fourth: {
			            	'age': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'sex': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'egfr': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'k': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'scr': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            	'ef': ['ARNI', 'SGLTi', 'GLP1-RA', 'nsMRA', 'sMRA', 'BetaBlocker', 'ACEiARB'],
			            }
			        }
		        };

		        selectedFirst.forEach(fromStart => {
		        	const clsFromStart = fromStart.replace(/[\s/]+/g, '');
    	        	const obj = map[clsFromStart];

    	        	// 1. first > second
    	        	if (obj.second) {
    	        		obj.second.forEach(cls => {
    	        			const from = document.querySelector(`.${clsFromStart}`);
    	        			const to = document.querySelector(`.${cls}`);

    	        			if (from && to) {
    	        				lines.push({ 
    	        					d: this.drawPath(from, to), 
    	        					color: obj.color 
    	        				});
    	        			}
    	        		});
    	        	}

    	        	// 2. first > third
    	        	if (obj.third && !obj.second) {
    	        		obj.third.forEach(cls => {
    	        			const from = document.querySelector(`.${clsFromStart}`);
    	        			const to = document.querySelector(`.${cls}`);

    	        			if (from && to) {
    	        				lines.push({ 
    	        					d: this.drawPath(from, to), 
    	        					color: obj.color 
    	        				});
    	        			}
    	        		});
    	        	}

    	        	// 3. second > third
    	        	if (obj.second && obj.third) {
    	        		obj.second.forEach(secondCls => {
    	        			obj.third.forEach(thirdCls => {
    	        				const from = document.querySelector(`.${secondCls}`);
    	        				const to = document.querySelector(`.${thirdCls}`);

    	        				if (from && to) {
    	        					lines.push({ 
    	        						d: this.drawPath(from, to), 
    	        						color: obj.color 
    	        					});
    	        				}
    	        			});
    	        		});
    	        	}

    	        	// 4. third > fourth
    	        	if (obj.fourth) {
    	        		for (const key in obj.fourth) {
    	        			const fourth = obj.fourth[key];

    	        			fourth.forEach(cls => {
    	        				const from = document.querySelector(`.${key}`);
    	        				const to = document.querySelector(`.${cls}`);

    	        				if (from && to) {
    	        					lines.push({ 
    		        					d: this.drawPath(from, to), 
    		        					color: obj.color 
    		        				});
    	        				}
    	        			});
    	        		}
    	        	}
		        });

		        fourthLi.forEach(liEl => {
		        	const from = document.querySelector(`.${liEl.dataset.val}`);
		        	const to = document.querySelector('.circle-max');
		        	
		        	if (from && to) {
				        lines.push({ 
	    					d: this.drawPath(from, to), 
	    					color:'#cccccc'
	    				});
		        	}
		        });

		        fourthLiSelected.forEach(liEl => {
		        	const from = document.querySelector(`.${liEl.dataset.val}`);
		        	const to = document.querySelector('.circle-min');
		        	
		        	if (from && to) {
				        lines.push({ 
	    					d: this.drawPath(from, to), 
	    					color:'#195a8d'
	    				});
		        	}
		        });

		        this.lines = lines;    
			},

			drawPath(from, to) {
				const rect = document.querySelector('.learn-more').getBoundingClientRect();

			    const f = from.getBoundingClientRect();
			    const t = to.getBoundingClientRect();

			    const x1 = f.right - rect.left;
			    const y1 = f.top + f.height / 2 - rect.top;
			    const x2 = t.left - rect.left;
			    const y2 = t.top + t.height / 2 - rect.top;

			    const mid = (x1 + x2) / 2;
			    return `M ${x1} ${y1} C ${mid} ${y1}, ${mid} ${y2}, ${x2} ${y2}`;
			},

			isRuleEnabled(ruleName) {
			 	return this.rules[ruleName] === true;
			}
		},
		computed: {
			totalMin() {
				let count = 0;

				if (this.answers.questionFirst.includes('AFF')) {
					count += Number(this.score.score_aff.min) || 0;
				} 

				if (this.answers.questionFirst.includes('Chronic Kidney Disease')) {
					count += Number(this.score.score_ckd.min) || 0;
				}

				if (this.answers.questionFirst.includes('ASCVD')) {
					count += Number(this.score.score_ascvd.min) || 0;
				} 

				if (this.answers.questionFirst.includes('HFrEF/HFmrEF') || this.answers.questionFirst.includes('HFpEF')) {
					count += Number(this.score.score_hf.min) || 0;
				}

				return count;
			},
			totalMax() {
			    let count = 0;

				if (this.answers.questionFirst.includes('AFF')) {
					count += Number(this.score.score_aff.max) || 0;
				} 

				if (this.answers.questionFirst.includes('Chronic Kidney Disease')) {
					count += Number(this.score.score_ckd.max) || 0;
				}

				if (this.answers.questionFirst.includes('ASCVD')) {
					count += Number(this.score.score_ascvd.max) || 0;
				} 

				if (this.answers.questionFirst.includes('HFrEF/HFmrEF') || this.answers.questionFirst.includes('HFpEF')) {
					count += Number(this.score.score_hf.max) || 0;
				}

				return count;
			},
			percent() {
				return this.totalMax ? (this.totalMin / this.totalMax) * 100 : 0;
			}
		}
	}
